// extracted by mini-css-extract-plugin
export default {"loader_container":"Loading_loader_container__2kZTg","loader":"Loading_loader__KHKmz"};